// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Norway from '../_raw/flag/icon_flag_norway.png';

export default () => <img src={Norway} alt="Norway" />;
